import { Autoplay } from 'swiper/modules';
import { SwiperProps } from 'swiper/react';

export const carouselConfig = {
  allowTouchMove: false,
  modules: [Autoplay],
  autoplay: { delay: 7000, pauseOnMouseEnter: true },
  loop: true,
  slidesPerView: 1,
  speed: 1000,
} satisfies SwiperProps;

export const carouselSwitchIntervalMs = 7000;
export const carouselSliderResetIntervalMs = 50; // 50ms reset
